import i18n from "../../../../i18n/i18n";
import { typeOfDocument } from "../../../../api/document";

/**
 * The collaborator document slots.
 *
 * `type` is the strongbox type the API stores against the document and is the
 * ONLY thing that should ever be matched on. It used to live in a switch on
 * the row id inside the component, where the identity slot was spelled
 * "indentity" - a typo that matched nothing the backend ever returns
 * (App\Models\Strongbox::TYPE_IDENTITY === "identity"), so the eye button on
 * the ID card row silently did nothing. Keeping the type next to the slot and
 * sourcing it from the shared enum means the two cannot drift again.
 */
export const dataDocuments = [
  {
    id: "1",
    icoName: "cards",
    title: i18n.t("collaborator.idCard", "Id card"),
    type: typeOfDocument.carte_d_identite,
  },
  {
    id: "2",
    icoName: "certificate",
    title: i18n.t("collaborator.liscence", "Liscence"),
    type: typeOfDocument.permis_de_conduire,
  },
];